angular
  .module("mercury.modules.stock.report")
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state("Stock.ReportSupplier", {
      url: "/report/supplier?report",
      templateUrl: "modules/stock/report/supplier.tpl.html",
      controller: "StockReportSupplierCtrl",
    });

    $stateProvider.state("Stock.ReportReceivedInvoices", {
      url: "/reports/received-invoices?start&end&dateRange&prevDateRange",
      controller: "ReactCtrl",
    });

    $stateProvider.state("Stock.ReportReceivedInvoicesExport", {
      url: "/reports/received-invoices/export?start&end&dateRange&prevDateRange",
      controller: "ReactCtrl",
      data: {
        menuLinkState: "Stock.ReportReceivedInvoices",
      },
    });

    $stateProvider.state("Stock.ReportSupplierEdit", {
      url: "/report/supplier/edit/:id?report",
      templateUrl: "modules/stock/purchaseorder/edit.tpl.html",
      controller: "StockPurchaseorderEditCtrl",
      data: {
        menuLinkState: "Stock.ReportSupplier",
      },
    });

    $stateProvider.state("Stock.ReportItem", {
      url: "/report/item?report",
      templateUrl: "modules/stock/report/item.tpl.html",
      controller: "StockReportItemCtrl",
    });

    $stateProvider.state("Stock.ReportItemEdit", {
      url: "/report/item/edit/:id?report",
      templateUrl: "modules/stock/purchaseorder/edit.tpl.html",
      controller: "StockPurchaseorderEditCtrl",
      data: {
        menuLinkState: "Stock.ReportItem",
      },
    });

    $stateProvider.state("Stock.ReportOverview", {
      url: "/report/overview?report",
      templateUrl: "modules/stock/report/overview.tpl.html",
      controller: "StockReportOverviewCtrl",
    });
  }]);
